<template>
  <scoped>
    <label
      v-if="title"
      :for="id"
    >
      {{ title }}
    </label>
    <input
      :id="id"
      v-model="value"
      :max="formatHTML(max)"
      :min="formatHTML(min)"
      type="date"
      :disabled="readOnly"
      @change="validate()"
    >
  </scoped>
</template>

<script setup lang="ts">
  import {useId} from "vue"

  const props = defineProps({
    max: {
      default: null,
      required: false,
      type: Date
    },
    min: {
      default: null,
      required: false,
      type: Date
    },
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    },
    title: {
      default: null,
      required: false,
      type: String
    }
  })
  const id = useId()
  const value = defineModel("value", {
    default: null,
    required: true,
    type: Date
  })

  function formatHTML(input: Date): string {
    if (input == null) {
      return null
    }

    let day = input.getDate().toString()
    if (day.length == 1) {
      day = `0${day}`
    }
    let month = (input.getMonth() + 1).toString()
    if (month.length == 1) {
      month = `0${month}`
    }
    return `${input.getFullYear()}-${month}-${day}`
  }

  function validate() {
    const date = new Date(value.value)
    if (props.min && date < props.min) {
      value.value = formatHTML(props.min)
    }
    if (props.max && date > props.max) {
      value.value = formatHTML(props.max)
    }
  }
</script>

<style scoped>
  input[type = "date"] {
    background-color: var(--color-white);
    border-color: var(--theme-color-primary);
    border-radius: var(--border-radius-small);
    border-style: solid;
    border-width: var(--border-width-light);
    display: block;
    margin: 0.5em 0;
    padding: 0.5em;

    &:focus, &:hover {
      border-color: var(--color-grey);
    }
  }

  label {
    display: block;
    font-weight: bolder;
  }
</style>
